import { createStoreModule } from '@/_core/fluxstore';
import { IAction } from '@/_core/fluxstore/types';
import { StorymapCardDetailsState } from './types';

const initState = () => {
    return new  StorymapCardDetailsState();
};

export const useStorymapCardDetailsStore = createStoreModule<StorymapCardDetailsState, IAction<StorymapCardDetailsState>>(initState, 'root-StorymapCardDetails');
